/**
 * O aviso de que o acesso da organização está acabando (`A-09`, ADR-060): só para o
 * administrador, só nos últimos sete dias (escolha de 09/10). Os outros usuários não veem — o
 * prazo é conversa do contrato, e quem decide renovar é quem administra. Não se fecha: some
 * quando o dono do banco muda a data, e a sessão traz a nova em até 15 minutos.
 */
import { avisoDeValidadeVisivel, dataDoAcesso, diasDeAcesso } from "../acesso";

export function AvisoDeValidade({
  acessoAte,
  perfil,
  agora,
}: {
  acessoAte: string | null | undefined;
  perfil: string | undefined;
  /** Para os testes; a tela usa o relógio do navegador. */
  agora?: Date;
}) {
  if (!acessoAte || !avisoDeValidadeVisivel(acessoAte, perfil, agora))
    return null;
  const dias = diasDeAcesso(acessoAte, agora);
  const quando =
    dias === 1
      ? `hoje, ${dataDoAcesso(acessoAte)}`
      : `${dataDoAcesso(acessoAte)} — faltam ${dias} dias`;
  return (
    <div
      role="status"
      className="rounded-cartao border border-amarelo-borda bg-amarelo-fundo px-3 py-2 text-[12px] text-amarelo"
    >
      O acesso desta organização ao Cockpit vale até {quando}. Para continuar
      depois disso, fale com a IA Solutions.
    </div>
  );
}
